import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MODULES, PERMISSION_ACTIONS } from '@shared/constants';
import { getModulePermission } from '@shared/utils';

import { ModuleGuard } from '../core/guards/module.guard';
import { PermissionGuard } from '../core/guards/permission.guard';

import { AddEditRoomsComponent } from './components/add-edit-rooms/add-edit-rooms.component';
import { MakeABookingComponent } from './components/make-a-booking/make-a-booking.component';
import { RoomsComponent } from './components/rooms/rooms.component';

const routes: Routes = [
  {
    path: '',
    component: RoomsComponent,
    canActivate: [ModuleGuard, PermissionGuard],
    data: {
      title: 'Rooms',
      goBackEnabled: true,
      searchBarEnabled: true,
    },
  },
  {
    path: 'create',
    component: AddEditRoomsComponent,
    canActivate: [ModuleGuard, PermissionGuard],
    data: {
      title: 'app.rooms.create',
      goBackEnabled: true,
      searchBarEnabled: false,
    },
  },
  {
    path: ':id/edit',
    component: AddEditRoomsComponent,
    data: {
      title: 'app.rooms.edit',
      goBackEnabled: true,
      edit: true,
      module: MODULES.ROOMS,
      allowedPermissions: getModulePermission(MODULES.ROOMS, [
        PERMISSION_ACTIONS.EDIT,
      ]),
    },
  },
  {
    path: ':id/make-a-booking',
    component: MakeABookingComponent,
    data: {
      title: 'app.rooms.make-a-booking',
      goBackEnabled: true,
      edit: true,
      module: MODULES.ROOMS,
      allowedPermissions: getModulePermission(MODULES.ROOMS, [
        PERMISSION_ACTIONS.EDIT,
      ]),
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RoomsRoutingModule {}
